import { readRmsDomains } from '@racepointenergy/swc/scs/read-rms-domains'

import { useAppSelector } from 'app/hooks'
import { isRootAdminSelector } from 'features/auth/permissions/selectors'
import { PERMISSIONS_POLLING_INTERVAL } from 'app/consts'
import { currentRootDomainIdSelector } from 'features/rootDomains/selectors'

export interface useUserTopDomainsWithNestingProps {
  domainId: string | undefined
}
// get User Top Domains data with subdomains
// for root user it will be his root domains with subdomains and it could be huge
// so we are skipping query if user isRootAdmin but unfortunately we still query it if he is not admin
// but there is no other way to check root user permissions in his subdomains
// for subdomain user it will be his top subdomains with sub-subdomains in domains tree
function useUserTopDomainsWithNesting({
  domainId,
}: useUserTopDomainsWithNestingProps) {
  const currentRootDomainId =
    useAppSelector(currentRootDomainIdSelector) || undefined
  const isRootAdmin = useAppSelector(isRootAdminSelector)
  const {
    data: userTopDomainsDataWithNesting,
    isError,
    isFetching,
    isSuccess,
  } = readRmsDomains.useQuery(
    { rootdomainid: currentRootDomainId, users: 'self', jobs: true },
    {
      skip: !domainId || isRootAdmin || !currentRootDomainId,
      pollingInterval: PERMISSIONS_POLLING_INTERVAL,
      refetchOnMountOrArgChange: true,
      refetchOnReconnect: true,
    }
  )

  return { userTopDomainsDataWithNesting, isError, isFetching, isSuccess }
}

export default useUserTopDomainsWithNesting
